import { callApi } from '@/api/apibase'

export const generateUserVerificationCode = function (email) {
  return callApi('GET', `/api/external/greencourse/GenerateUserVerificationCode?email=${encodeURIComponent(email)}`)
}
